export default "__VITE_ASSET__BN2vk6CO__"